import React, { Component } from "react";
import AddAuthor from "../AddAuthor/AddAuthor";

class EditAuthor extends Component {
  render() {
    return (
      <AddAuthor
        editStatus={true}
        authorId={this.props.match.params.authorId}
      />
    );
  }
}

export default EditAuthor;
